// extracted by mini-css-extract-plugin
export default {"readableContent":"ReadableContent_readableContent__Cdt1l"};